<template>
  <div>
    <div class="section-title">{{ questionContent }}</div>
    <div class="top-questions">
      <Loading v-if="loading" />
      <template v-else>
        <SegmentedTabs
          :tabs="questions"
          v-model="activeName"
          container-width="100%"
          @change="handleTabChange"
        />
        <ul class="topic-container">
          <li v-for="topic in topics" :key="topic.id" @click="goDetail(topic)">
            <div class="topic-name">{{ topic.content }}</div>
            <!-- <img :src="moreIcon" alt="更多" class="more-icon" /> -->
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>
<script>
import SegmentedTabs from '@/components/common/components/SegmentedTabs.vue'
import api from '../../api/api'
import { track } from '@/utils/tracking.js'
import moreIcon from '@/assets/image/ic_more.png'
import Loading from '@/components/common/components/loading.vue'

export default {
  name: 'TopQuestions',
  props: {
    questionContent: {
      type: String,
      default: '猜你想问',
    },
    appid: {
      type: String,
      default: '',
    },
    enterid: {
      type: String,
      default: '',
    },
    sign: {
      type: String,
      default: '',
    },
  },
  components: {
    SegmentedTabs,
    Loading,
  },
  data() {
    return {
      moreIcon,
      activeName: '',
      questions: [],
      topics: [],
      loading: true,
    }
  },
  methods: {
    handleTabChange(tab) {
      this.activeName = tab.categoryName
      // 保存到 sessionStorage，返回时恢复
      sessionStorage.setItem('topQuestionsActiveTab', this.activeName)
      this.questions.forEach((item) => {
        if (item.categoryName === tab.categoryName) {
          this.topics = item.hotQuestions || []
        }
      })
    },

    getHotProblems() {
      this.loading = true
      api
        .getHotProblems({
          appid: this.appid,
          enterid: this.enterid,
          sign: this.sign,
        })
        .then((res) => {
          if (
            res &&
            Array.isArray(res.classificationVos) &&
            res.classificationVos.length > 0
          ) {
            this.questions = res.classificationVos
            // 优先从 sessionStorage 恢复选中状态，否则选中第一个
            const savedTab = sessionStorage.getItem('topQuestionsActiveTab')
            const hasValidTab =
              savedTab &&
              this.questions.some((q) => q.categoryName === savedTab)
            const targetTab = hasValidTab
              ? savedTab
              : res.classificationVos[0].categoryName
            this.handleTabChange({
              categoryName: targetTab,
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    goDetail(item) {
      // c: 猜你想问：统计用户点击猜你想问模块内问题的数量
      track({
        param: {
          eventCode: 'faq_click',
          pageCode: 'self_service_page',
        },
      })
      const query = {
        appid: this.appid,
        enterid: this.enterid,
        sign: this.sign,
        name: item.content,
        id: item.id,
        activeTab: this.activeName,
      }
      this.$router.push({
        name: 'solution',
        query,
      })
    },
  },

  mounted() {
    this.getHotProblems()
  },
}
</script>
<style scoped lang="less">
.top-questions {
  width: 100%;
  background-color: #fff;
  .px2rem(border-radius, 12);
  .px2rem(padding-top, 12);
  .px2rem(padding-bottom, 0);
  .px2rem(padding-left, 16);
  box-sizing: border-box;

  .tabs-container {
    .tabs-scroll-wrapper {
      .tab-item {
        font-weight: 500;
      }
    }
  }
}
.section-title {
  .px2rem(font-size, 16);
  font-weight: 500;
  color: #1a1d25;
  .px2rem(margin-bottom, 12);
  .px2rem(line-height, 24);
  .px2rem(padding-left, 12);
}

.topic-container {
  list-style: none;
  margin: 0;
  padding: 0;
  .px2rem(padding-right, 12);
  li {
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
    .px2rem(height, 40);
    display: flex;
    align-items: center;

    .topic-name {
      // .px2rem(padding-right, 6);
      flex: 1;
      width: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #1a1d25;
      font-family: "PingFang SC";
      font-weight: 400;
      .px2rem(font-size, 14);
    }

    .more-icon {
      .px2rem(width, 12);
      .px2rem(height, 12);
    }
  }
}
</style>
